import type { ReactNode } from "react";
import InquiryFormSection from "../components/InquiryFormSection";
import pmImage from "../assets/pm.jpg";
import shanghaiImage from "../assets/shanghai.png";

type ContactUsCard = {
  title: string;
  subtitle: string;
  description: string;
  icon: ReactNode;
};

type ContactTabProps = {
  contactUsCards: ContactUsCard[];
  companyPartners: string[];
  apiBaseUrl: string;
  turnstileSiteKey?: string;
};

export default function ContactTab({
  contactUsCards,
  companyPartners,
  apiBaseUrl,
  turnstileSiteKey
}: ContactTabProps) {
  return (
    <section className="mb-10 space-y-14 md:mb-16">
      <div className="relative h-[260px] overflow-hidden md:h-[360px]">
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{ backgroundImage: `url('${shanghaiImage}')` }}
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[rgba(8,13,21,0.25)] via-[rgba(8,13,21,0.55)] to-[rgba(8,13,21,0.7)]" />
        <div className="relative z-10 flex h-full items-center justify-center px-6 text-center">
          <h2 className="text-3xl font-semibold text-white md:text-5xl">
            Contact Us
          </h2>
        </div>
      </div>

      <div className="mx-auto w-full max-w-[1140px] px-4 md:px-8 lg:px-10">
        <div className="grid gap-8 md:grid-cols-3">
          {contactUsCards.map((card) => (
            <article
              key={card.title}
              className="rounded-2xl border border-[#eef2f6] bg-white p-6 text-center shadow-[0_16px_36px_rgba(15,23,36,0.08)]"
            >
              <div className="flex items-center justify-center">{card.icon}</div>
              <h3 className="mt-4 text-base font-semibold text-[#111827]">
                {card.title}
              </h3>
              <p className="mt-2 text-xs font-semibold uppercase tracking-[0.3em] text-[#9aa3af]">
                {card.subtitle}
              </p>
              <p className="mt-3 text-sm leading-relaxed text-[#6b7280]">
                {card.description}
              </p>
            </article>
          ))}
        </div>
      </div>

      <div className="mx-auto w-full max-w-[1140px] px-4 pb-6 md:px-8 lg:px-10">
        <div className="text-center">
          <p className="text-sm font-semibold uppercase tracking-[0.3em] text-[#f3b455]">
            Personalized Trips
          </p>
          <h3 className="mt-4 text-3xl font-semibold text-[#111827] md:text-4xl">
            Contact us for a Quote
          </h3>
        </div>
        <InquiryFormSection
          apiBaseUrl={apiBaseUrl}
          turnstileSiteKey={turnstileSiteKey}
          source="contact"
          imageSrc={pmImage}
          imageAlt="Contact inspiration"
          partners={companyPartners}
        />
      </div>
    </section>
  );
}
